import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import * as Chart from 'chart.js';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ContestAndIncentiveDetailsService } from '../services/contest-and-incentive-details.service';
import { OfflineService } from 'src/app/offline/offline.service';

@Component({
  selector: '',
  template: '',
})
export class SegmentationSearchHandler
  extends BaseSearchComponent<ContestAndIncentiveDetailsService>
  implements OnInit
{
  public chartOptions;
  public searchName: string;
  public segmentationOriginalJsonData;

  @Output() closeChart = new EventEmitter<string>();

  constructor(
    public agentService: ContestAndIncentiveDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(agentService, router, headerService);
    this.searchName = 'SearchSegmentation';
  }

  ngOnInit() {
    this.agentService.find(this.searchName).subscribe(
      (searchList) => {
        const list = JSON.parse(JSON.stringify(searchList));
        this.segmentationOriginalJsonData = list.data.searchResultData;
      },
      (error) => {
        console.log('Get search list failed.', error);
      }
    );
  }

  onCloseClick() {
    this.closeChart.emit(Chart);
  }
}
